// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DealsModule } from '../deals/deals.module';
import { DocumentFormModule } from '../document-form/document-form.module';
import { MaterialModule } from '../../shared/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { SharedModule } from '../../shared/shared.module';
import { AddNewDocumentComponent } from './add-new-document/add-new-document.component';
import { DealDetailsComponent } from './deal-details/deal-details.component';
import { DealDocumentsComponent } from './deal-documents/deal-documents.component';
import { DealRootComponent } from './deal-root/deal-root.component';
import { DealComponent } from './deal.component';
import { DocumentUploadComponent } from './document-upload/document-upload.component';
import { DocumentViewComponent } from './document-view/document-view.component';

@NgModule({
    declarations: [
        DealComponent,
        AddNewDocumentComponent,
        DealDetailsComponent,
        DealDocumentsComponent,
        DealRootComponent,
        DocumentUploadComponent,
        DocumentViewComponent,
    ],
    imports: [CommonModule, DealsModule, DocumentFormModule, FormsModule, MaterialModule, PipesModule, ReactiveFormsModule, RouterModule, SharedModule],
})
export class DealModule {}
